<template>
  <div class="wrapper">
    <div id="formContent">
      <!-- Tabs Titles -->

      <!-- Icon -->
      <div>
        <font-awesome-icon :icon="['fas', 'user']" size="5x" class="m-auto text-primary pt-3" />
        <h3>Login</h3>
      </div>

      <!-- Login Form -->
      <form @submit.prevent="login">
        <input
          type="text"
          id="login"
          name="login"
          placeholder="Email"
          class="form-control"
          v-model="email"
        />
        <input
          :type="view ? 'text' : 'password'"
          id="password"
          name="login"
          placeholder="password"
          v-model="password"
        />
        <font-awesome-icon
          id="loginPassword"
          fas
          :icon="view ? 'eye-slash' : 'eye'"
          size="2x"
          @click="toggleView"
        />
        <input
          type="submit"
          value="Log In"
          :disabled="isValid == false"
          class="btn btn-lg btn-primary my-3 py-2 px-5"
        />
      </form>

      <!-- Remind Passowrd -->
      <div id="formFooter" class="mx-3">
        <b-link class="underlineHover" :to="{name:'ForgotPassword'}">Forgot Password?</b-link>
        <b-button
          variant="primary"
          class="text-white mt-1"
          block
          to="/register?t=candidate"
        >Don't have an account? Register as a candidate today!</b-button>
        <!-- <b-button
          variant="primary"
          class="text-white mt-1"
          block
          to="/register?t=company"
        >Don't have an account? Register as a company today!</b-button> -->
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
@import "../styles/views/_login.scss";
</style>
<script>
import WordItNicely from "@/misc/WordItNicely";
import firebase from "@/Firebase";
import Auth from "@/fstore/auth";
var validator = require("email-validator");

export default {
  data() {
    return {
      view: false,
      email: "",
      password: "",
      error: null
    };
  },
  computed: {
    isValid: function() {
      return validator.validate(this.email) && this.password !== "";
    }
  },
  methods: {
    toggleView() {
      this.view = !this.view;
    }, //end toggleView
    async login() {
      try {
        const status = await this.$store.dispatch('auth/login', {
          email: this.email,
          password: this.password
        });
        
        if(status.code !== 200) {
          this.$store.dispatch("app/setAlert", {
            type: "danger",
            message: WordItNicely(status.code)
          }); //end dispatch alert
          return
        }

        this.$router.push(status.redirectURL);
      } catch (error) {
        console.error(error);
        this.$store.dispatch("app/setAlert", {
          type: "danger",
          message: WordItNicely(error.code)
        }); //end dispatch alert
      }
    }
  },
  mounted() {
    if (this.$route.query.p == "verificationfailure") {
      this.$parent.$emit(
        "displayAlert",
        "danger",
        "This account has not been verified, please go to your inbox to verify your email before logging in"
      );
    } //end if
  } //end mounted
};
</script>
